'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function MainTitle({ h1Override, resourceKey, className = '', params }) {
  return h(
    'h2.main-title',
    h(
      `span.main-title-text.${className}`,
      h1Override ||
        h(
          Translate,
          {
            ...params,
          },
          resourceKey
        )
    )
  );
}

module.exports = MainTitle;
